import { useState } from "react";
import MUITypography from "@mui/material/Typography";
import MUIStepper from "@mui/material/Stepper";
import MUIStep from "@mui/material/Step";
import MUIStepLabel from "@mui/material/StepLabel";

export default function HorizontalStepper(props) {
    const [activeStep, setActiveStep] = useState(props.activeStep ?? 0);
    const controlledActiveStep = props.activeStep ?? activeStep;

    // TODO isStepFailed will happen in step 1 if we get an error from pVerify
    // TODO: Use this when we get invalid pVerify results
    // const isStepFailed = (index) => {
    //     return index === 1;
    // };


    return (
        <MUIStepper activeStep={controlledActiveStep}>
            {props.steps.map((step, index) => {
                const labelProps = {};
                if (step?.description) {
                    labelProps.optional = (
                        <MUITypography variant="caption">
                            {step.description}
                        </MUITypography>
                    );
                }

                return (
                    <MUIStep key={step.label}>
                        <MUIStepLabel {...labelProps}>{step.label}</MUIStepLabel>
                    </MUIStep>
                );
            })}
        </MUIStepper>
    );
}